<template>
  <div id="bookingTrue">
      <!--
      <div class="header">
          <div class="container-header">
            <p class="montserrat-semibold white">Reserva exitosa</p>
            
            CLOSE MODAL
            <div class="close">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 2L2 17" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 2L17 17" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
          </div>
      </div> -->

      <div class="content-modal">
          
        <div class="header-content">
            <!-- ILUSTRATION MODAL -->
            <svg width="84" height="155" viewBox="0 0 84 155" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.6452 16.4206C-4.89983 53.6204 -1.64574 112.413 4.03248 146.292C4.84965 151.168 9.12413 154.628 14.0678 154.628H53.5953C58.8233 154.628 63.247 150.773 63.8433 145.579C67.7557 111.497 71.3713 53.1549 48.4169 16.6197C41.6555 5.85803 26.6448 5.8123 19.6452 16.4206Z" fill="#2CB9B0" fill-opacity="0.54"/>
                <path d="M17.9266 122.521L23.0458 130.003C24.3257 131.874 27.0781 131.897 28.3886 130.047L33.0636 123.449C34.4643 121.472 37.4568 121.664 38.5941 123.803L41.2689 128.835C42.4361 131.03 45.5344 131.159 46.8804 129.069L50.8897 122.841C52.0963 120.967 54.7871 120.832 56.1746 122.577L62.1095 130.039C63.4971 131.783 66.1878 131.649 67.3944 129.774L72.0022 122.617C73.194 120.766 75.8414 120.607 77.246 122.302L83.1256 129.399" stroke="white" stroke-opacity="0.5" stroke-width="1.62766" stroke-linecap="round"/>
                <path d="M33.3672 154.628L33.3672 134.282" stroke="#2CB9B0" stroke-width="0.81383"/>
                <path d="M33.3672 87.0798L33.3672 33.367" stroke="#2CB9B0" stroke-width="0.81383"/>
                <path d="M32.8678 121.168C41.1318 121.219 47.8725 114.561 47.9237 106.297C47.9748 98.0334 41.317 91.2927 33.0531 91.2415C24.7891 91.1904 18.0484 97.8482 17.9972 106.112C17.9461 114.376 24.6039 121.117 32.8678 121.168Z" stroke="black" stroke-width="3.25532" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M26.9561 109.16C26.9561 109.16 29.182 112.167 32.9228 112.19C36.6636 112.213 38.9266 109.234 38.9266 109.234" stroke="black" stroke-width="3.25532" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M28.499 101.687L28.5178 101.687" stroke="black" stroke-width="3.25532" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M36.4551 101.687L36.4738 101.687" stroke="black" stroke-width="3.25532" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <h3 class="montserrat-bold gray-medium">Tu reserva se ha confirmado</h3>
        </div>
        

        <!-- INFO BOOKING -->
        <div class="info-booking">
            <!-- NAME COURSE -->
            <p
             class="montserrat-bold black mt-2 name-course">Curso de Verano - Agosto 2022</p>
            
            <!-- DATE & HOUR CLASS -->
            <div class="mt-2">
                <!-- DATE CLASS -->
                <span class="montserrat-semibold black is-size-text-normal">
                    Miércoles 6 de Abril,</span>

                <!-- HOUR CLASS -->
                <span class="montserrat black is-size-text-normal">
                    7:00 AM - 9:00AM </span>
            </div>

            <div class="mt-2 is-size-text-normal">
                <span class="opensans black">Estudiante:</span>

                <!-- NAME STUDENT -->
                <span class="OpenSans-Bold black ml-2">Joselito Carnaval</span>
            </div>

            <div class="mt-2 is-size-text-normal">
                <!-- NUMBER STUDENT -->
                <p class="montserrat-medium black">12 / 20 estudiantes inscritos</p>
            </div>

            <div class="mt-2 is-flex is-size-text-normal">
                <!-- <div>
                    <span class="OpenSans-SemiBold gray-medium">Nivel:</span>
        
                    <span class="ml-1 opensas gray-medium">Principiante</span>
                </div> -->

                <div class="mletf">
                    <span class="OpenSans-SemiBold gray-medium">Mentor:</span>

                    <!-- NAME MENTOR -->
                    <span class="ml-1 black opensans">Felix</span>
                </div>

                
            </div>
            <div class="mt-2 is-size-text-normal">
                <span class="OpenSans-SemiBold gray-medium">Lugar:</span>
                <!-- PLACE-->
                <span class="opensans black gray-medium ml-2">Costa Adeje</span>
            </div>

        </div>

        <button class="mt-6 button-primary-extra-medium">
            Aceptar</button>
          
      </div>    
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.header {
    background-color: #3C3C3C;
    height: 85px;
    padding-top: 42px;
}

.container-header {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: space-between;
}

.name-course {
    font-size: 18px;
}

.mletf {
    margin-left: 30px;
}

.content-modal {
    width: 97%;
    margin: auto;
    padding-bottom: 20px;
    max-width: 488px;
}

.header-content {
    display: flex;
    align-items: flex-end;
    padding-bottom: 10px;
    border-bottom: 1px solid #EDEDED;
    margin-top: 42px;
}

.header-content h3 {
    font-size: 18px;
    margin-bottom: 15px;
    max-width: 210px;
}

.name-course {
    font-size: 16px;
}

.info-booking {
    margin-top: 25px;
}


</style>